import React from "react";
var __jsx = React.createElement;
var UspItem = function UspItem(_ref) {
  var src = _ref.src,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "px-2 py-4 flex flex-col gap-2 bg-primary justify-between rounded-lg z-[2]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: title,
    loading: "lazy",
    width: "40px",
    height: "40px"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-white text-center font-bold text-xss max-w-[70px] mx-auto leading-4 lg:max-w-full lg:text-sm"
  }, title)));
};
export default UspItem;